import styled from 'styled-components';

/**
 * Корневой узел для создания пользовательского степпера.
 * Стилизованный компонент, обладающий всеми свойствами ``div``.
 */
export const StepperRoot = styled.div`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    width: max-content;
`;
